import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0133',
    ecrans: [
        '00-2',
        '01-2'
    ]
});
